export { default } from './PaymentMethodsList';
